import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'
import { GroupFile } from '@/modules/group/modules/groups/domain/models/GroupFile'

import { axios, Response } from '../../index'

export type PatientGroup = {
  id: string
  name: string
  category: GroupConfigurationCategory
  groupFiles: GroupFile[]
  totalMembers: number
}

const getPublishableGroupsByPatient = (
  patientId: string
): Response<PatientGroup[]> => {
  return axios.get(`/v1/patient/${patientId}/groups`)
}

export default getPublishableGroupsByPatient
